class GetRollingDetails {
  constructor(details) {
    this.details = details;
    this.summary = details.querySelector('.get-rolling__summary');
    this.content = details.querySelector('.get-rolling__answer');
    if (!this.summary || !this.content) return;

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.details.style.overflow = 'hidden';

    if (this.isClosing || !this.details.open) {
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    this.details.classList.add('is-closing');
    this.details.classList.remove('is-open');

    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: 320, easing: 'ease-out' }
    );

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.details.style.height = `${this.details.offsetHeight}px`;
    this.details.open = true;
    this.details.classList.add('is-open');
    this.details.classList.remove('is-closing');
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;

    const startHeight = `${this.details.offsetHeight}px`;
    const endHeight = `${this.details.scrollHeight}px`;

    if (this.animation) this.animation.cancel();

    this.animation = this.details.animate(
      { height: [startHeight, endHeight] },
      { duration: 360, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)' }
    );

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.details.classList.remove('is-closing');
    if (!open) this.details.classList.remove('is-open');
    this.details.style.height = '';
    this.details.style.overflow = '';
  }
}

function initGetRolling(root = document) {
  root.querySelectorAll('.get-rolling__details').forEach((el) => {
    if (el.dataset.grInit) return;
    el.dataset.grInit = 'true';
    new GetRollingDetails(el);
  });
}

if (document.readyState !== 'loading') {
  initGetRolling();
} else {
  document.addEventListener('DOMContentLoaded', () => initGetRolling());
}

document.addEventListener('shopify:section:load', (e) => initGetRolling(e.target));
